import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";
import { useDispatch } from "react-redux";

// const dispatch = useDispatch();

//enachh added
export const AddENACHDetails = (payload) => {
  //console.log("Payload-Action" ,payload);
  return {
    type: actionTypes.FETCH_ENACH,
    formData: payload,
  };
};
